module.exports = __webpack_public_path__ + "static/media/6.e9beffe7.jpg";